<body class="flex  fixed inset-0 items-center justify-center rounded-full" >
    <img src="assets/images/logo.png" class="rounded-full">
      <div class="loader">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
      </div>
    </body>

  <!-- <body class="flex fixed inset-0 items-center justify-center bg-white">
  <div class="flex flex-col items-center">
    <img src="assets/images/logo.png" class="rounded-full w-24 h-24 mb-6" alt="Logo" />
    <div class="loader">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</body> -->
